import { createFeatureSelector, createSelector } from '@ngrx/store';
import { favoriteFeatureKey, FavoriteState } from '@store/reducers';

const selectState = createFeatureSelector<FavoriteState>(favoriteFeatureKey);

export const selectFavoritesList = createSelector(
    selectState,
    (state: FavoriteState) => state.favorites
);
